module.exports = __webpack_public_path__ + "img/zinly.c44a2bdc.jpeg";